<app-mid-button type="primary" icon="fas fa-plus" (action)="onAddUserClick()">
  {{ 'ADD_USER' | translate }}
</app-mid-button>
